import './attachCeremony.less';
import * as _ from 'lodash';
import { TimeString } from '../../../misc/TimeString';

/**
 * @typedef { import('../../../objects/Ceremony').Ceremony } Ceremony
 * @typedef { import('../../../objects/MeetingLookupResult').MeetingLookupResult } MeetingLookupResult
 */

export class AttachCeremonyModel {
    /**
     * @param {Ceremony}
     */
    constructor(ceremony) {
        this.ceremony = ceremony;
        /** @type {MeetingLookupResult} */
        this.meeting = null;
        this.presentTime = ceremony.CeremonyTime;
    }

    get isValid() {
        return this.meeting != null;
    }

    get hasChanges() {
        if (this.meeting != null) return true;
        if (this.presentTime !== this.ceremony.CeremonyTime) return true;
        return false;
    }

    createAttach() {
        return {
            MeetingId: this.meeting.Id,
            PresentTime: this.presentTime,
        };
    }
}

class AttachCeremonyController {

    constructor() {
        /** @type {AttachCeremonyModel} */
        this.model = null;
    }

    /**
     * 
     * @param {any} changed
     */
    $onChanges(changed) {
        if (changed.model) {
            if (this.model) {
                this.ceremony = this.model.ceremony;
            } else {
                this.ceremony = null;
            }
        }
    }

    isAttendanceWithin() {
        if (this.model && this.model.meeting && this.model.presentTime) {
            let meetingTs = TimeString.parse(this.model.meeting.MeetingTime);
            let presentTs = TimeString.parse(this.model.presentTime);
            return meetingTs.contains(presentTs);
        }
        return true;
    }
    
    meetingChanged(meeting) {
        if (this.model) {
            this.model.meeting = meeting;
        }
    }
}

angular.module("tromanWeb").component('ergoAttachCeremony', {
    template: require('./attachCeremony.html'),
    bindings: {
        model: '<',
        organizations: '<',
    },
    controller: AttachCeremonyController
});

